import { useApiClient } from "@/infrastructure/rest/apiClient";
import { useMutation } from "@tanstack/react-query";

export function useResetEnvironment() {
    const apiClient = useApiClient();

    return useMutation({
        mutationFn: async () => {
            await apiClient.post(`/debug/reset-environment`);
        },
        onError: (error) => {
            console.error("Fout bij aanmaken bestelling:", error);
        },
    });
}
